import { collection, getDocs, writeBatch, doc } from 'firebase/firestore';
import { db } from '../config/firebase';

export async function updateExistingRequests() {
  try {
    const requestsRef = collection(db, '2dr_requests');
    const snapshot = await getDocs(requestsRef);
    
    // Utiliser des lots (batches) pour les mises à jour
    const batchSize = 500; // Limite de Firestore pour les opérations par lot
    let batch = writeBatch(db);
    let operationCount = 0;
    
    for (const document of snapshot.docs) {
      const data = document.data();
      
      // Nettoyer le titre et les détails
      const cleanedTitle = cleanString(data.title || '');
      const cleanedDetails = cleanString(data.details || '');
      
      // Mettre à jour le document avec les versions nettoyées
      const docRef = doc(db, '2dr_requests', document.id);
      batch.update(docRef, {
        titleLower: cleanedTitle,
        detailsLower: cleanedDetails
      });
      
      operationCount++;
      
      // Si nous atteignons la limite du lot, nous le committons et en créons un nouveau
      if (operationCount === batchSize) {
        await batch.commit();
        batch = writeBatch(db);
        operationCount = 0;
        console.log(`Lot de ${batchSize} documents mis à jour`);
      }
    }
    
    // Committer le dernier lot s'il reste des opérations
    if (operationCount > 0) {
      await batch.commit();
      console.log(`Dernier lot de ${operationCount} documents mis à jour`);
    }
    
    console.log('Mise à jour des documents terminée avec succès');
    return true;
  } catch (error) {
    console.error('Erreur lors de la mise à jour des documents:', error);
    return false;
  }
}

// Fonction pour nettoyer les données lors de la création/modification d'une demande
export function prepareRequestData(data: any) {
  // Nettoyer les chaînes de caractères
  if (data.title) data.title = cleanString(data.title);
  if (data.details) data.details = cleanString(data.details);
  
  return data;
}

export function cleanString(str: string): string {
  if (!str) return '';
  
  // Supprimer les caractères non imprimables et les caractères de contrôle
  return str.replace(/[\x00-\x1F\x7F-\x9F]/g, '');
} 